<template>
  <v-dialog v-model="isVisible" class="notification-card-wrapper" persistent max-width="600px">
    <div class="notification-card">
      <div class="notification-image"
      :style="{
        'background-image': `url(${imageUrl})`
      }"
      >
        <div class="notification-title">
          <div class="notification-title-content">
            <h1>{{ title }}</h1>
          </div>
        </div>
      </div>
      <div class="notification-content">
        <template v-for="(cont, i) in content">
          <p v-if="cont.contentType === 'p'" :key="i">
            <template v-if="Array.isArray(cont.content)">
              <template v-for="(span, j) in cont.content">
                <span :key="`${i}-${j}`" :style="span.style ? span.style : ''">
                  {{ span.text }}
                </span>
              </template>
            </template>
            <template v-else>
              {{ cont.content }}
            </template>
          </p>
        </template>
      </div>
      <div class="notification-actions">
        <v-btn v-if="link" color="info" text @click="navigateToLink(link.url)">
          {{ link.label }}
        </v-btn>
        <v-btn class="pull-right" color="secondary" @click="close()">
          Okay
        </v-btn>
        <div v-if="!link" class="notification-end" />
      </div>
    </div>
  </v-dialog>
</template>
<script>
  export default {
    components: {},
    props: {
      isVisible: { type: Boolean, default: false },
      title: { type: String, default: '' },
      imageUrl: { type: String, default: '' },
      content: { type: Array, default: () => [] },
      link: { type: Object, default: undefined, required: false },
    },
    data () {
      return {}
    },
    methods: {
      close () {
        this.$emit('closed')
      },
      navigateToLink (url) {
        window.open(url)
      },
    },
  }
</script>

<style>
.v-dialog{
  border-radius: 16px;
}

.notification-card{
  background: #D9D9D9;
}

.notification-image{
  width: 100%;
  height: 300px;
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
}

.notification-title{
  position: absolute;
  width: 100%;
  bottom: 0;
  background: linear-gradient(to bottom, rgba(0,0,0,0.4), rgba(0,0,0,0.7));
  color: #ffffff;
}

.notification-title-content{
  padding: 0 12px;
}

.notification-content, .notification-actions{
  padding: 12px;
}

.notification-actions{
  padding-bottom: 24px;
}

.pull-right{
  float: right;
}

.notification-end {
  width: 100%;
  height: 35px;
}
</style>
